import React from "react";
import "./aicta.css";
import { Container } from "react-bootstrap";


const AiCta = ({ data }) => {
  return (
    <section
      className="ai-roadmap-cta"
      style={{
        "--cta-bg": data.colors.background,
        "--cta-title": data.colors.title,
        "--cta-description": data.colors.description,
        "--cta-button-bg": data.colors.buttonBackground,
        "--cta-button-text": data.colors.buttonText,
        "--cta-button-border": data.colors.buttonBorder,
        "--accent-left": data.accent.leftColor,
        "--accent-right": data.accent.rightColor,
        "--box-shadow": data.colors.boxShadow,
      }}
    >
    <Container>
      <div className="ai-roadmap-cta__content">
        <div className="ai-roadmap-cta__copy">
          <h2>
            {data.title.map((line, index) => (
              <React.Fragment key={index}>
                {line}
                {index < data.title.length - 1 && <br />}
              </React.Fragment>
            ))}
          </h2>

          <div className="ai-roadmap-cta__description">
            {data.description.map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>

          <div className="ai-roadmap-cta__accent">
            <span />
            <span />
          </div>
        </div>

        <a
          className="ai-roadmap-cta__button"
          href={data.button.href}
        >
          {data.button.label}
        </a>
      </div>
    </Container>  
    </section>
  );
}

export default AiCta